module.exports = "<app-a-calendar></app-a-calendar>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/my-attendance/my-attendance.component.html
// module id = ../../../../../src/app/home/my-attendance/my-attendance.component.html
// module chunks = common